// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3y32_","title":"AfterFrontImage_title__2v1VL"};